import { useEffect, useRef, useState } from "react";
import { http } from "./api";

// Sondea un trabajo; llama onDone solo si lo vio correr y terminar (o siempre, con `nuevo`, si el trabajo se lanzó en esta pantalla).
export const useJob = (eid, jid, onDone, nuevo = false) => {
  const [job, setJob] = useState(null);
  const cb = useRef(onDone);
  cb.current = onDone;
  useEffect(() => {
    if (!jid) return undefined;
    let alive = true;
    let wasRunning = false;
    let t;
    const tick = async () => {
      try {
        const r = await http.get(`/expedientes/${eid}/jobs/${jid}`);
        if (!alive) return;
        setJob(r.data);
        if (["queued", "running"].includes(r.data.status)) {
          wasRunning = true;
          t = setTimeout(tick, 2000);
        } else if (wasRunning || nuevo) cb.current?.(r.data);
      } catch { /* trabajo eliminado */ }
    };
    tick();
    return () => { alive = false; clearTimeout(t); };
  }, [eid, jid]);
  return job;
};

export const isRunning = (job) => !!job && ["queued", "running"].includes(job.status);
